import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateService, TranslatePipe , TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TooltipModule } from 'angular2-tooltips';

import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Calendar } from '@ionic-native/calendar';

import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { IonicImageViewerModule } from 'ionic-img-viewer';
import { TreeModule } from 'angular-tree-component';

import { NouveauxChapitresApp } from './app.component';
import { RestrictedAccessManager } from '../pages/restrictedaccess';
import { GalleryService } from '../providers/gallery-service/gallery-service';
import { RestGuestService } from '../providers/guest-service/rest-guest-service';
import { RestEventService } from '../providers/event-service/rest-event-service';
import { RestNewsService } from '../providers/news-service/rest-news-service';
import { RestRoomOffersService } from '../providers/room-offers-service/rest-room-offers-service';
import { RoomOffersService } from '../providers/room-offers-service/room-offers-service';
import { CarpoolingOffersService } from '../providers/carpooling-offers-service/carpooling-offers-service';
import { RestCarpoolingOffersService } from '../providers/carpooling-offers-service/rest-carpooling-offers-service';
import { ForumService } from '../providers/forum-service/forum-service';
import { RestForumService } from '../providers/forum-service/rest-forum-service';
import { CommentService } from '../providers/comment-service/comment-service';


@NgModule({
	declarations : [
		NouveauxChapitresApp
	],
	imports : [
		BrowserModule,
		HttpModule,
		IonicModule.forRoot(NouveauxChapitresApp, {
      //backend url config
      //backendUrl: 'http://localhost:3000'//localhost
      //backendUrl: 'http://52.15.157.84'//AWS
	  backendUrl: 'http://159.65.22.210:3000'//DigitalOcean
    }, 
{
  links: [
    { loadChildren: '../pages/address/address.module#AddressPageModule', name: 'AddressPage', segment: 'address', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/details/details.module#DetailsPageModule', name: 'DetailsPage', segment: 'details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery/gallery.module#GalleryPageModule', name: 'GalleryPage', segment: 'gallery', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery-engagement/gallery-engagement.module#GalleryEngagementPageModule', name: 'GalleryEngagementPage', segment: 'gallery-engagement', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery-honeymoon/gallery-honeymoon.module#GalleryHoneymoonPageModule', name: 'GalleryHoneymoonPage', segment: 'gallery-honeymoon', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery-tab/gallery-tab.module#GalleryTabPageModule', name: 'GalleryTabPage', segment: 'gallery-tab', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery-wedding/gallery-wedding.module#GalleryWeddingPageModule', name: 'GalleryWeddingPage', segment: 'gallery-wedding', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/guest-book/guest-book.module#GuestBookPageModule', name: 'GuestBookPage', segment: 'guest-book', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/guest-list/guest-list.module#GuestListPageModule', name: 'GuestListPage', segment: 'guest-list', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/guest-offers/guest-offers.module#GuestOffersPageModule', name: 'GuestOffersPage', segment: 'guest-offers', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/honeymoon/honeymoon.module#HoneymoonPageModule', name: 'HoneymoonPage', segment: 'honeymoon', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/information/information.module#InformationPageModule', name: 'InformationPage', segment: 'information', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/registry/registry.module#RegistryPageModule', name: 'RegistryPage', segment: 'registry', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/rsvp/rsvp.module#RSVPPageModule', name: 'RSVPPage', segment: 'rsvp', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/save-the-date/save-the-date.module#SaveTheDatePageModule', name: 'SaveTheDatePage', segment: 'save-the-date', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/schedule/schedule.module#SchedulePageModule', name: 'SchedulePage', segment: 'schedule', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/thread/thread.module#ThreadPageModule', name: 'ThreadPage', segment: 'thread', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/topics/topics.module#TopicsPageModule', name: 'TopicsPage', segment: 'topics', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/welcome/welcome.module#WelcomePageModule', name: 'WelcomePage', segment: 'welcome', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicImageViewerModule,
    TreeModule,
    TooltipModule,
		TranslateModule.forRoot({
      loader: {
        provide : TranslateLoader,
        useFactory : (createTranslateLoader),
        deps : [Http]
      }
		})
	],
	bootstrap : [IonicApp],
	entryComponents : [
		NouveauxChapitresApp
	],
	providers : [
    StatusBar,
    SplashScreen,
    {
      provide: LOCALE_ID,//useValue: "fr-CH"
      deps: [TranslateService],
      useFactory: (translateService) => translateService.currentLang
    },
    { provide: 'GuestService', useClass: RestGuestService },
    { provide: 'CommentService', useClass: CommentService },
    { provide: 'EventService', useClass: RestEventService },
    { provide: 'GalleryService', useClass: GalleryService },
    { provide: 'NewsService', useClass: RestNewsService },
    { provide: 'CarpoolingOffersService', useClass: RestCarpoolingOffersService },
    { provide: 'RoomOffersService', useClass: RestRoomOffersService },
    { provide: 'NewsService', useClass: RestNewsService },
    { provide: 'ForumService', useClass: RestForumService },
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    RestrictedAccessManager,
    Calendar,
	]
})
export class AppModule {}
export function createTranslateLoader(http : Http) : TranslateLoader {
	return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts